<template>
  <div class="amp_main">
    <div class="amp_con" v-loading="loading">
      <div class="flex_bet_h">
        <span class="tools_tit">音量放大</span>
        <img src="../../assets/images/img2/offlogin.png" class="tools_off" @click="hide" />
      </div>
      <div class="tools_upfile" @click="show_list = true">
        <div v-if="wodk_url == ''">
          <img src="../../assets/images/img2/addfile.png" class="tools_addfile" />
          <p>添加音频</p>
        </div>
        <div v-else>
          <p class="amp_url overflow_hide">{{ wodk_url }}</p>
          <p>已选择</p>
        </div>
      </div>
      <p class="tools_tit2">放大倍数</p>
      <div class="tools_ampcon">
        <p class="flex_bet_h">
          <span class="tools_amptext1">温馨提示: 音量放大可能会导致音频失真</span>
          <span class="tools_amptext2">{{ amp_val }}倍</span>
        </p>
        <el-slider v-model="amp_val" :min="1" :max="10"></el-slider>
        <p class="flex_bet_h">
          <span>1倍</span>
          <span>10倍</span>
        </p>
      </div>
      <div class="flex_bet_h">
        <div class="tools_btn" @click="startAmplification(false)" v-if="!play_state">
          <img src="../../assets/images/play.png" class="tools_btn_icon" />
          <span>试听效果</span>
        </div>
        <div class="tools_btn" @click="stopPlay" v-else>
          <img src="../../assets/images/pause.png" class="tools_btn_icon" />
          <span>暂停播放</span>
        </div>
        <div class="tools_btn tools_btn2" @click="qryApiLimit(true)">
          <img src="../../assets/images/img2/exfile.png" class="tools_btn_icon" />
          <span>导出音频</span>
        </div>
      </div>
    </div>
    <audioLiist v-if="show_list" @hide="show_list = false" @setWork="setWork" />
  </div>
</template>
<script>
// 作品选择组件
import audioLiist from "./audio_list.vue";
export default {
  components: {
    audioLiist,
  },
  data() {
    return {
      amp_val: 1, //放大倍数
      show_list: false, //作品选择组件显示状态
      wodk_url: "", //放大作品链接
      loading: false, //加载动画状态
      audio: new Audio(), //播放器
      play_state: false, //播放状态
      time: null,
    };
  },
  destroyed() {
    this.audio.src = "";
  },
  methods: {
    // 停止播放
    stopPlay() {
      this.audio.pause();
      this.play_state = false;
    },
    // 监听播放状态
    monitorPlay() {
      let self = this
      this.time = setInterval(() => {
        if (self.audio.ended) {
          self.play_state = false;
          clearInterval(self.time);
        }
      }, 1000);
    },
    // 查询接口调用次数
    qryApiLimit(isextend) {
      this.$globalFun.qryApiLimit(this,'2',()=>{ 
        this.startAmplification(isextend)
      })
    },
    // 放大音量
    startAmplification(isextend) {
      // isextend？true=导出音频：false=试听效果
      let self = this;
      if (this.wodk_url == "") {
        this.$message({
          message: "请选择需要放大音量的音频",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      let url = self.$store.state.app_api + self.$store.state.app_url.ttsvoice;
      let json = {
        mp3url: this.wodk_url,
        voice: this.amp_val,
      };
      this.$request.postHttp(json, url, (response) => {
        self.loading = false;
        let mp3url = response.model.mp3url;
        if (!mp3url) {
          self.$message.error("操作失败！");
        }
        if (!isextend) {
          self.audio.src = mp3url;
          self.audio.play();
          self.play_state = true;
          self.monitorPlay()
        } else {
          // this.$globalFun.uptApiLimit(this,'2')
          this.$globalFun.downloadDub(mp3url);
        }
      })
    },
    // 选择作品
    setWork(e) {
      this.show_list = false;
      this.wodk_url = e.musicpath;
    },
    hide() {
      this.$emit("hide");
    },
  },
};
</script>
<style>
@import url("../../assets/css/tools.css");
</style>



// WEBPACK FOOTER //
// src/components/tools/amplification.vue